import { render, staticRenderFns } from "./UserProperties.vue?vue&type=template&id=68eabb44"
import script from "./UserProperties.ts?vue&type=script&lang=ts&external"
export * from "./UserProperties.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports